import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ScreenUtils } from 'src/app/core/utils/screen-utils/screen-utils';
import { MetaPageEnum } from '~/core/declaration/declaration';
import { AssetService } from '~/core/services/assets/asset.service';
import { MetaTagService } from '~/core/utils/global-utils/global-utils';
@Component({
  selector: 'volvo-trade-export-page',
  templateUrl: './trade-export-page.component.html',
  styleUrls: ['./trade-export-page.component.scss']
})
export class TradeExportPageComponent implements OnInit {
  isTablet: boolean = false
  constructor(
    private metaTagService: MetaTagService,
    private translateService: TranslateService,
    public assetService: AssetService) { }
  ngOnInit(): void {
    if (ScreenUtils.isTablet()) this.isTablet = true;
    this.metaTagService.updateTagFor(MetaPageEnum.Services);
  }
  getBackgroundStyle(): { [key: string]: string } {
    const style = `url(${this.assetService.getAssetUrl('assets/pages/aboutUs/AboutusimageTX.webp')}) center 44% / cover no-repeat`;
    return { 'background': style };
  }
}
